module.exports = __webpack_public_path__ + "img/GATEWAY(TELESCOPIC) CONVEYOR.094add21.jpg";